import $ from 'jquery';
import api from './apiService';
import {populateFields, propSpinner} from "./utils";

import Noty from 'noty';
import 'noty/lib/noty.css';
import 'noty/lib/themes/mint.css';

$(document).ready(function () {
    let mapFields = (data) => ({
        'id': data.policyNumber,
        'dati_della_polizza[cod_preventivo]': data.quotationNumber,
        'dati_tecnici[targa]': data.plateNumber,
        'dati_della_polizza[decorrenza]': data.startDate,
        'dati_della_polizza[termine]': data.endDate,
        'dati_della_polizza[scadenza_rata_successiva]': data.nextPaymentDate,
        'dati_della_polizza[premio_annuo]': data.premium,
        'dati_della_polizza[frazionamento]': data.frazionamento,
        'dati_della_polizza[prima_rata]': data.primaRate,
        'dati_della_polizza[imposte]': data.imposta,
        'dati_della_polizza[ssn]': data.ssn,
        'insurance_company_id': data.insuranceCompanyId,
        'insurance_branch_id': data.insuranceBranchId,
    });

    // Find all file inputs with the js-parse-document class
    const $fileInputs = $('.js-parse-document');

    if ($fileInputs.length === 0) {
        return;
    }
    $fileInputs.on('change', async function (event) {
        const files = event.target.files;

        if (!files || files.length === 0) {
            return;
        }
        const file = files[0];

        const formData = new FormData();
        formData.append('file', file);

        let fields = Object.keys(mapFields({}))
        propSpinner(fields, true);
        resetRepeatableGaranzieField();
        try {
            const response = await api.postData('/api/app/backpack/parse-pdf-policy', formData, {
                handleError: false,
            });

            if (response && typeof response === 'object') {
                fillFormFields(response.data);
            }
        } catch (error) {
            new Noty({
                type: "warning",
                text: ('Error parsing document:' + error.response.data.message)
            }).show();
        } finally {
            propSpinner(fields, false);
        }
    });


    function fillFormFields(data) {
        data = Object.fromEntries(Object.entries(data).filter(([_, value]) => value !== null && value !== undefined && value !== ''));
        populateFields(mapFields(data));

        if (data.owner || data.contractor) {
            fillRepeatableField(data);
        }

        if (data.garanzie) {
            fillRepeatableGaranzieField(data);
        }
    }

    function fillRepeatableField(data) {
        const $repeatableField = $('[data-repeatable-holder="dati_anagrafici"]');

        if (!$repeatableField.length) {
            return;
        }

        if (data.contractor) {
            const contractorData = {
                rapporto: 'Contraente',
                nome: data.contractor.name,
                cognome: data.contractor.surname,
                codice_fiscale: data.contractor.tax_code,
                via: data.contractor.address,
                cap: data.contractor.postal_code,
                citta: data.contractor.city,
                provincia: data.contractor.province,
                email: data.contractor.email,
                telefono: data.contractor.phone
            };

            fillOrCreateRepeatableElement('Contraente', contractorData);
        }

        if (data.owner) {
            const ownerData = {
                rapporto: 'Proprietario',
                nome: data.owner.name,
                cognome: data.owner.surname,
                codice_fiscale: data.owner.tax_code,
                via: data.owner.address,
                cap: data.owner.postal_code,
                citta: data.owner.city,
                provincia: data.owner.province,
                email: data.owner.email,
                telefono: data.owner.phone
            };

            fillOrCreateRepeatableElement('Proprietario', ownerData);
        }
    }

    function fillOrCreateRepeatableElement(role, data) {
        // Find existing element with the specified role
        let $element = null;
        const $repeatableElements = $('.repeatable-element[data-repeatable-identifier="dati_anagrafici"]');

        $repeatableElements.each(function () {
            const $roleSelect = $(this).find('select[data-repeatable-input-name="rapporto"]');
            if ($roleSelect.length && $roleSelect.val() === role) {
                $element = $(this);
                return false;
            }
        });

        if (!$element) {
            $('.add-repeatable-element-button').click();

            $element = $('.repeatable-element[data-repeatable-identifier="dati_anagrafici"]').last();

            const $roleSelect = $element.find('select[data-repeatable-input-name="rapporto"]');
            $roleSelect.val(role).trigger('change');
        }

        Object.entries(data).forEach(([field, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                const $field = $element.find(`[data-repeatable-input-name="${field}"]`);
                if ($field.length) {
                    $field.val(value).trigger('change');
                }
            }
        });
    }

    function fillRepeatableGaranzieField(data) {
        const $repeatableField = $('[data-repeatable-holder="garanzie"]');

        if (!$repeatableField.length) {
            return;
        }

        const usedElements = [];

        data.garanzie.forEach(function (item) {
            const garanzieData = {
                categoria: item.categoria || '',
                descrizione: item.descrizione || '',
                imponibile_annuo_scont: item.imponibile_annuo_scont || '',
                imposta: item.imposta || '',
                importo_ssn: item.importo_ssn || '',
                premio_netto_giornaliero_scont: item.premio_netto_giornaliero_scont || ''
            };

            fillOrCreateRepeatableGaranzieElement(garanzieData, usedElements);
        });
    }

    function fillOrCreateRepeatableGaranzieElement(data, usedElements = []) {
        const wrapper = $('#garanzie-wrapper');
        const holder = wrapper.find('[data-repeatable-holder="garanzie"]');
        const repeatableElements = holder.find('.repeatable-element[data-repeatable-identifier="garanzie"]');

        let element = null;

        repeatableElements.each(function () {
            const $this = $(this);
            const $descrizioneInput = $this.find('[data-repeatable-input-name="descrizione"]');
            const descrizioneVal = $descrizioneInput.val();

            if (usedElements.includes(this)) {
                return;
            }

            if (!descrizioneVal || descrizioneVal === data.descrizione) {
                element = $this;
                usedElements.push(this);
                return false;
            }
        });

        if (!element) {
            wrapper.find('.add-repeatable-element-button').click();

            const allElements = holder.find('.repeatable-element[data-repeatable-identifier="garanzie"]');
            element = allElements.last().get(0);
            usedElements.push(element);
            element = $(element);
        }

        Object.entries(data).forEach(([field, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                const $field = element.find(`[data-repeatable-input-name="${field}"]`);
                if ($field.length) {
                    $field.val(value).trigger('change');
                }
            }
        });
    }

    function resetRepeatableGaranzieField() {
        const wrapper = $('#garanzie-wrapper');
        const holder = wrapper.find('[data-repeatable-holder="garanzie"]');
        const elements = holder.find('.repeatable-element[data-repeatable-identifier="garanzie"]');

        elements.each(function () {
            const $removeBtn = $(this).find('[data-repeatable-delete-button]');
            if ($removeBtn.length) {
                $removeBtn.click();
            } else {
                $(this).remove();
            }
        });

        if (wrapper.data('min-rows') === 1 || wrapper.find('.add-repeatable-element-button').length) {
            wrapper.find('.add-repeatable-element-button').click();
        }
    }

})
